import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Button, Modal, Table, Alert, Spinner } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';
import { ViewManager } from '../../core/view-manager';
import FieldPreview from '../../components/Entity/FieldPreview';


export default function DataGridSelectionHook({ data, setData, entity = null, selectedRows, setSelectedRows }) {


    const navigate = useNavigate()
    
    useEffect(() => {
        
    }, []);


    
    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch(entity) {
                        case 'test': return (
                            <span>Test</span>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};